var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-menu-item",class:_vm.cssClass,on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon",style:(_vm.itemStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }